import * as Dialog from "@radix-ui/react-dialog";
import { ExternalLink, HardDrive, ShieldCheck, X } from "lucide-react";

export function AboutDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }): React.JSX.Element {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="dialog-content about-dialog" aria-describedby="about-description">
          <div className="dialog-header">
            <div>
              <Dialog.Title>About ModelMotive</Dialog.Title>
              <Dialog.Description id="about-description">Local-first parametric CAD · version 0.1.0</Dialog.Description>
            </div>
            <Dialog.Close className="icon-button" aria-label="Close"><X size={16} /></Dialog.Close>
          </div>
          <div className="about-body">
            <div className="about-brand-block">
              <img src="./icons/icon.svg" alt="" />
              <div><strong>ModelMotive</strong><span>Design real things. Entirely on your device.</span></div>
            </div>
            <div className="about-principles">
              <span><HardDrive size={16} /><strong>Local projects</strong><small>Autosaves use browser-managed storage.</small></span>
              <span><ShieldCheck size={16} /><strong>Private by design</strong><small>Models stay local. Ads use a separate shared service.</small></span>
            </div>
            <section className="about-license-notice">
              <h3>Geometry technology and licence notice</h3>
              <p>
                ModelMotive uses RepliCAD and Open CASCADE Technology (OCCT) for exact solid modelling.
                OCCT is distributed under GNU LGPL version 2.1 with the Open CASCADE additional exception.
              </p>
              <div className="about-links">
                <a href="./THIRD_PARTY_NOTICES.txt" target="_blank" rel="noreferrer">Third-party notices <ExternalLink size={13} /></a>
                <a href="./licenses/OCCT-LGPL-2.1.txt" target="_blank" rel="noreferrer">LGPL 2.1 text <ExternalLink size={13} /></a>
                <a href="./licenses/OCCT-LGPL-EXCEPTION.txt" target="_blank" rel="noreferrer">OCCT exception <ExternalLink size={13} /></a>
              </div>
            </section>
            <p className="about-note">ModelMotive files remain on this device unless you explicitly export or share them.</p>
          </div>
          <div className="dialog-footer"><Dialog.Close className="button primary">Done</Dialog.Close></div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
